module.exports = __webpack_public_path__ + "static/media/logo-ko-cdphp.c43f4be8.svg";